// removed by extract-text-webpack-plugin
module.exports = {"BackBtn":"ProfileName__BackBtn__1WwmP","SubmitBtn":"ProfileName__SubmitBtn__2BxuA","Name":"ProfileName__Name__P5kig"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/ProfileName/ProfileName.css
// module id = 375
// module chunks = 0